import { trackEvent } from '../tools'

export default {
  testTrack(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_m_test_track',
      eventLabel: '门店端基座测试埋点',
      attrs,
    })
  },
}
